export default "__VITE_ASSET__BlF69DZ0__"